export const FEATURE_LIMIT_WARNING_RANGE = {
  min: 80,
  max: 100,
}

export const MAX_LIMIT_VALUE_DECIMALS = 3

export const UNLIMITED_FEATURE_LIMIT_VALUES = [-1, 999999, 999999999]

export const INVALID_FEATURE_LIMIT_VALUES = [undefined, 0]
